import { Spinner } from 'flowbite-react';

function LoadingPage() {
  return (
    <div className="mx-auto w-fit py-40">
      <Spinner size="xl" />
    </div>
  );
}

function WaitLoading({ children, isLoading }) {
  return isLoading || isLoading === undefined ? <LoadingPage /> : children;
}

export default WaitLoading;
